import React, { useState } from "react";
// import { registerUser } from "../api/auth";
import { useNavigate, Link } from "react-router-dom";
import "../../styles/LoginandRegister/login.css";
import UserInfo from "../../componant/User/UserInfo";
import { add_user } from "../../api/serverWrapper";
import { saveData } from "../../utils/localstorage_constants";
import {
  IS_ADMIN,
  IS_LOGGED,
  USER_DATA,
} from "../../utils/localstorage_variables";
const Register = () => {
  const [user, setUser] = useState(new UserInfo(null));
  let [confirmpassword, setConfirmPassword] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setUser({ ...user, [e.target.name]: e.target.value });

  const handleConfirmPassword = (e) => {
    confirmpassword = e.target.value;
    setConfirmPassword(confirmpassword);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (user.Password !== confirmpassword) {
      return alert("password and confirm password dont match");
    }
    setUser({ ...user, IsAdmin: true });
    delete user.id;
    const res = await add_user(user);
    if (res.success) {
      let userresp = res.data;
      saveData(IS_LOGGED, true);
      saveData(IS_ADMIN, userresp.IsAdmin ? true : false);
      saveData(USER_DATA, userresp);
      alert("Registered successfully.");
      navigate("/", { replace: true });
    } else {
      alert(res.message || "Registration failed");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Register</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="Name"
            value={user.Name}
            placeholder="Full Name"
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="PhoneNumber"
            value={user.PhoneNumber}
            placeholder="Phone number"
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="Email"
            placeholder="Email"
            value={user.Email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="Password"
            value={user.Password}
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            value={confirmpassword}
            placeholder="Confirm Password"
            onChange={handleConfirmPassword}
            required
          />
          <button type="submit">Register</button>
        </form>
        <p>
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
